import { userAuthContextType } from '../../auth/AuthProvider';
import { axios, settings, getResponse } from '../../helpers/main';

const { backend, } = settings;
const authServices = { user: userAuthContextType, }; //eslint-disable-line

const objectService = getResponse({ type: 0 }); //eslint-disable-line
/**
 * Service to manage communication with the RemoteConnections API.
 * Follows the Single Responsibility Principle (SRP) by separating network logic from the UI.
 */
export const RemoteConnectionService = {
    /**
     * Retrieves all RemoteConnections and related master data (customers).
     * @param {Object} params - Query parameters.
     * @param {authServices} params.auth - User authentication object (passed from the component).
     * @param {number} params.languageId - Current language ID.
     * @param {string} [params.subMethod=''] - Sub-method name for error traceability.
     * @returns {Promise<objectService>} Promise with the API response.
     */
    getAll: async ({
        auth,
        languageId,
        subMethod = '',
    } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.remoteConnections}/`,
            headers: {
                authorization: `bearer ${auth?.user?.token?.token}`,
            },
            data: {
                method: backend?.methods?.remoteConnections.getAll,
                languageId: languageId,
            },
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },

    /**
     * Retrieves a single RemoteConnection details by ID.
     * @param {Object} params - Query parameters.
     * @param {authServices} params.auth - User authentication object.
     * @param {number|string} params.id - RemoteConnection ID.
     * @param {number} params.languageId - Current language ID.
     * @param {string} [params.subMethod=''] - Sub-method name for error traceability.
     * @returns {Promise<objectService>} Promise with the API response.
     */
    getById: async ({
        auth,
        id,
        languageId,
        subMethod = '',
    } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.remoteConnections}/`,
            headers: {
                authorization: `bearer ${auth?.user?.token?.token}`,
            },
            data: {
                method: backend?.methods?.remoteConnections?.getById,
                id: id,
                languageId: languageId,
            },
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },
};
